module.exports = __webpack_public_path__ + "static/media/background1.56ea5e3a.png";